import {
  Row,
  Col,
  Card,
  Button,
  // Typography,
  Input,
  Empty
} from 'antd';
import {
  InfoCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import './index.css'
import { Link, useLocation, useParams } from 'react-router-dom';
import { 
  // getBlogs, 
  getFixtures 
} from '../../apis/fixture.api';
import { useEffect, useState, useMemo } from 'react';
import {categories, CATEGORY_LINKS, HOME_PATH, OTHER_CATEGORIES, PAGE_TITLES } from '../../utils/constant';
import Loader from '../../components/common/Loader';
import Title from 'antd/es/typography/Title';
import { styles } from '../../styles';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';
import { getTimer } from '../../utils/timer';
import { Description } from '../Descriptions';
// import Paragraph from 'antd/es/typography/Paragraph';
import JoinDiscord from '../../components/social/discord';

const cardStyle = {
  border: '1px solid rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  height: '100%',
};

const headerStyle: any = {
  display: 'flex',
  justifyContent: 'flex-start',
};

const iconStyle = {
  color: '#adc6ff',
  marginRight: '10px',
  fontSize: '21px',
  strokeWidth: '15px',
  alignItems: 'middle'
};

export default function Home() {
  const matches = useMediaQuery('(min-width: 1000px)');
  const [fixtures, setFixtures] = useState<any>([]);
  // const [blogs, setBlogs] = useState<any>([]);
  const [noFixtures, setNoFixtures] = useState<boolean>(false);
  const { categoryName } = useParams();
  const [loader, setLoader] = useState<boolean>(false);
  // const [blogLoader, setBlogLoader] = useState<boolean>(true);
  const location = useLocation();
  const isBuffstream = location.pathname.includes('/buffstream');
  
  // Search filter state
  const [searchQuery, setSearchQuery] = useState<string>('');

  const getAllFixtures = async () => {
    setLoader(true);
    const selectedCat = categoryName ?? 'Streams Today';
    const categoryObj = categories.find((cat: any) => (cat.label).toLowerCase() === selectedCat?.toLowerCase());
    const category = categoryObj?.value;

    const response: any = await getFixtures({ categoryName: category });
    if (!response?.data?.subCategories[0]?.games?.length) {
      setNoFixtures(true);
    } else {
      setNoFixtures(false);
    }
    setFixtures(response.data);
    setLoader(false);
  }

  // const getAllBlogs = async () => {
  //   setBlogLoader(true);
  //   try {
  //     const dbBlogs = await getBlogs();
  //     setBlogs(dbBlogs.data || []);
  //   } catch (error) {
  //     setBlogs([]);
  //   } finally {
  //     setBlogLoader(false);
  //   }
  // }

  // Filter fixtures based on search query
  const filteredFixtures = useMemo(() => {
    if (!fixtures?.subCategories) return fixtures;
    
    let filteredSubCategories = fixtures.subCategories;
    
    // Filter by search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filteredSubCategories = filteredSubCategories.map((cat: any) => {
        const filteredGames = (cat.games || []).filter((game: any) => {
          return (
            (game.teamA?.toLowerCase().includes(query)) ||
            (game.teamB?.toLowerCase().includes(query)) ||
            (cat.subCategoryName?.toLowerCase().includes(query))
          );
        });
        
        return { ...cat, games: filteredGames };
      });
      
      // Remove empty subcategories
      filteredSubCategories = filteredSubCategories.filter((cat: any) => 
        cat.games && cat.games.length > 0
      );
    }
    
    return { ...fixtures, subCategories: filteredSubCategories };
  }, [fixtures, searchQuery]);

  function CategoryCard({ category }: any) {
    return (
      <>{category?.games?.length > 0 &&
        <Col style={{ marginBottom: '8px', justifyContent: 'center' }} span={24}>
          <Card
            size='small'
            title={
              <div style={headerStyle}>
                <span style={{ display: 'flex', alignItems: 'center', color: 'rgb(152 236 226)', fontSize: '18px', textTransform: 'capitalize' }}>
                  {category?.subCategoryImage ?
                    <img style={{ width: '30px', paddingRight: '10px' }}
                      src={category?.subCategoryImage}
                      alt={category?.subCategoryName}
                    /> : <InfoCircleOutlined style={iconStyle} />}
                  {category?.subCategoryName?.toUpperCase()}
                </span>
              </div>
            }
            extra={!categoryName && CATEGORY_LINKS[category?.subCategoryName?.toUpperCase()] &&
              <Link to={`/streams/${CATEGORY_LINKS[category?.subCategoryName?.toUpperCase()]}`}
                style={styles.more} className='more'> More</Link>}
            style={cardStyle}
          >
            <Row gutter={24}>
              {category?.games?.map((fixture: any, index: any) => (
                <Col span={12} key={index} style={{ padding: '0px' }}>
                  <FixtureCard fixture={{ ...fixture, category: category?.subCategoryName }} />
                </Col>
              ))}
            </Row>
          </Card>
        </Col>}
      </>
    );
  }

  function Timer({ timerValue }: any) {
    return (
      <strong style={timerValue === 'Live' ? { color: 'red' } : {}}>{timerValue}</strong>
    );
  }

  function YoutubeHighlightsLink() {
    return (
      <Button
      type="primary"
      className="watch-highlights-btn"
    >
      ▶ Highlights
    </Button>
    );
  }

  function CardContent({ fixture }: any) {
    return (
        <div className='fixture-card'>
            <div className='fixture-link'>
                <div className='flex-display'>
                  {matches && <p className='category'>{!OTHER_CATEGORIES.includes(fixture?.category) ? 'Soccer' : fixture?.category.toUpperCase()} </p>}
                  {matches && <span className='dash'></span>}
                  <p className='team-name'>
                    <span>
                      {!matches && <strong>{fixture.teamA}</strong>}
                      <img className='fixture-image' src={fixture.teamAImage} alt={`${fixture?.subCategoryName} - ${fixture.teamA}`} />
                    </span>
                    {matches && <strong>{fixture.teamA}</strong>}
                  </p>
                  {fixture?.teamB ? <p className='verses'>vs</p> : ''}
                  {fixture?.teamB && <p className='team-name' style={{ margin: '0px' }}>
                    <strong>{fixture.teamB}</strong>{' '}
                    <span><img className='fixture-image' src={fixture.teamBImage} alt={`${fixture?.subCategoryName} - ${fixture.teamB}`} /></span>
                  </p>}
                </div>
            </div>
            {fixture?.matchDate && <p className='match-time'>
              <Timer timerValue={getTimer(fixture)}></Timer>
            </p>}

              {!fixture?.matchDate &&
              <YoutubeHighlightsLink /> }
        </div>
    );
  }

  function FixtureCard({ fixture }: any) {
    let link = `/fixture/${fixture.teamA}-vs-${fixture.teamB}`;
    if(!fixture?.matchDate) {
      const home = fixture?.teamA ?? '';
      const away = fixture?.teamB ?? '';
      const league = fixture?.subCategoryName ?? '';

      const query = encodeURIComponent(
        `${home} vs ${away} highlights ${league}`
      );

      link = `https://www.youtube.com/results?search_query=${query}`;
    }

    return fixture?.matchDate ? (
      <Link
        to={link}
      >
        <CardContent fixture={fixture} />
      </Link>
    ) : (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <CardContent fixture={fixture} />
      </a>
    );
  }

  useEffect(() => {
    document.title = categoryName ? PAGE_TITLES[categoryName?.toUpperCase()] : PAGE_TITLES.WEBSITE_TITLE;
    getAllFixtures();
    // getAllBlogs();
  }, [categoryName]);

  // useEffect(() => {
  //   if (blogs.length === 0 && !blogLoader) {
  //     getAllBlogs();
  //   }
  // }, []);

  return (
    <>
      <Row gutter={24}
        style={{ 
          justifyContent: 'center',
          display: 'flex',
          padding: '12px 0px 0px 0px',
        }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{paddingBottom: '0px'}}>
          <Link 
            to='/fifa-world-cup-2026'
            style={{
              display: 'inline-flex',
              textDecoration: 'none',
              background: 'linear-gradient(135deg, #212121 0%, rgb(40, 108, 100) 100%)',
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(255, 180, 71, 0.25)',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              border: 'none',
              textAlign: 'center',
              width: '100%',
              maxWidth: '360px',
              padding: '8px 16px',
              marginBottom: matches ? '0px': '10px',
              marginRight: matches ? '10px': '0px'
            }}
          >
            <span style={{ 
              color: '#fff', 
              fontSize: 'clamp(14px, 3.5vw, 18px)',
              fontWeight: 500,
            }}>
            FIFA WorldCup 2026 Guide
            </span>
          </Link>

          <JoinDiscord/>
        </Col>
      </Row>

      {/* SEARCH FILTER SECTION */}
      <Row
        gutter={24}
        style={{ 
          justifyContent: 'center',
          display: 'flex',
          padding: '12px 12px'
        }}
      >
        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
          <Input
            placeholder="Search fixtures, teams, or categories..."
            prefix={<SearchOutlined />}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            size="large"
            style={{
              borderRadius: '4px',
              width: '100%',
              margin: '12px auto',
            }}
            allowClear
          />
          {searchQuery && (
            <div style={{ 
              textAlign: 'center', 
              marginTop: 8,
              color: '#fff',
              fontSize: '14px'
            }}>
              {filteredFixtures?.subCategories?.reduce((acc: number, cat: any) => 
                acc + (cat.games?.length || 0), 0) || 0} games found
            </div>
          )}
        </Col>
        {!categoryName && <Col xs={24} sm={24} md={6} lg={5} xl={5}>
        </Col>}
      </Row>

      {/* MAIN CONTENT */}
      <Row
        gutter={24}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {/* FIXTURES COLUMN (70%) */}
        <Col
          xs={24}
          sm={24}
          md={20}
          lg={20}
          xl={20}
        >
          {loader ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Loader />
            </div>
          ) : categoryName && noFixtures ? (
            <div>
              <Title level={3} style={{ color: '#fff' }}>
                No Fixtures Found For {categoryName.toUpperCase()}
              </Title>
              <Title level={3}>
                <Link to={HOME_PATH}>
                  <Button style={styles.homeButton}>Home</Button>
                </Link>
              </Title>
            </div>
          ) : filteredFixtures?.subCategories?.length > 0 ? (
            filteredFixtures.subCategories.map((category: any, index: number) => (
              <CategoryCard key={index} category={{ ...category }} />
            ))
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span style={{ color: '#94a3b8' }}>
                  {searchQuery ? 'No fixtures found matching your search' : 'No fixtures available'}
                </span>
              }
              style={{ 
                padding: '40px 0',
                background: 'rgba(26, 26, 26, 0.5)',
                borderRadius: '8px'
              }}
            >
              {searchQuery && (
                <Button type="primary" onClick={() => setSearchQuery('')}>
                  Clear Search
                </Button>
              )}
            </Empty>
          )}
        </Col>

      </Row>

      {/* DESCRIPTION ROW */}
      <Row
        gutter={24}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Col xs={24} md={matches ? 20 : 16}>
          {!loader && !categoryName && !isBuffstream && (
            <Description />
          )}
        </Col>
      </Row>
    </>
  );
}